module.exports = __webpack_public_path__ + "static/media/f-inst.5118454a.svg";